var map = {
	"./favicon.ico": 4,
	"./favicon_114.png": 5,
	"./favicon_120.png": 6,
	"./favicon_144.png": 7,
	"./favicon_152.png": 8,
	"./favicon_57.png": 9,
	"./favicon_60.png": 10,
	"./favicon_72.png": 11,
	"./favicon_76.png": 12,
	"./favicon_fb.png": 13,
	"./windows_large.png": 14,
	"./windows_square.png": 15,
	"./windows_tiny.png": 16,
	"./windows_wide.png": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;